// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"leaderboard"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M9 4H15V20H9V4Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M15 12H21V20H15V12Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M3 10H9V20H3V10Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 20V4H9V20M15 20H9M15 20V12H21V20H15ZM9 20V10H3V20H9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LeaderboardIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'leaderboard',
    ref,
    icon: element,
  },
));

LeaderboardIcon.displayName = 'LeaderboardIcon';

export default LeaderboardIcon;
